import $ from 'jquery'

$(window).on('show.bs.modal', () => {
  window.flash_messages && window.flash_messages.clearMessages()
})
